import { IconTicket } from './icons'

// Lucide ChevronDown (closed) / ChevronUp (open), inlined to avoid an icon-lib
// dependency. Size + color come from the passed className.
function HeaderChevron({ open, className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {open ? <path d="m18 15-6-6-6 6" /> : <path d="m6 9 6 6 6-6" />}
    </svg>
  )
}

/**
 * Three-column header:
 *   LEFT   — avatar + chevron, opens the side drawer (Part 4)
 *   CENTER — clapperboard logo, optically centered (logo only, no action)
 *   RIGHT  — ticket pill (opens the store)
 * Left/right columns take equal flex so the logo stays centered regardless of
 * their content widths. Safe-area top inset is handled in .g-header CSS.
 */
export default function GlobalHeader({ user, tickets, onMenuToggle, menuOpen, onOpenStore, partyHostMode, showLogo = true }) {
  // Party host mode: just the centered logo, no controls.
  if (partyHostMode) {
    return (
      <header className="g-header g-header--party-host">
        <div className="g-header__center">
          <img src="/clapperboard.png" alt="Action!" className="g-header__logo-img clapper-shimmer" draggable={false} />
        </div>
      </header>
    )
  }

  const avatar = user?.avatar

  return (
    <header className="g-header">
      {/* LEFT — avatar opens the drawer */}
      <div className="g-header__side g-header__side--left">
        <button
          type="button"
          className="g-header__avatar-btn"
          onClick={onMenuToggle}
          aria-label="Open menu"
          aria-expanded={menuOpen}
        >
          <span className="g-header__avatar">
            <img
              src={avatar || '/clapperboard.png'}
              alt=""
              onError={(e) => { if (!e.currentTarget.src.endsWith('/clapperboard.png')) e.currentTarget.src = '/clapperboard.png' }}
            />
          </span>
          <HeaderChevron open={menuOpen} className="g-header__avatar-chevron" />
        </button>
      </div>

      {/* CENTER — logo only (hidden on Home, where the hero lockup replaces it) */}
      <div className="g-header__center">
        {showLogo && (
          <img src="/clapperboard.png" alt="Action!" className="g-header__logo-img clapper-shimmer" draggable={false} />
        )}
      </div>

      {/* RIGHT — ticket pill */}
      <div className="g-header__side g-header__side--right">
        <button
          type="button"
          className="g-header__tickets"
          onClick={onOpenStore}
          aria-label={`${tickets} tickets — open store`}
        >
          <span className="g-header__tickets-text"><IconTicket size={16} color="var(--accent-gold)" style={{ verticalAlign: 'middle' }} /> {tickets}</span>
        </button>
      </div>
    </header>
  )
}
